import React from "react";
import { Link } from "react-router-dom";
import mark from "../assets/ro-mark.png";
import { business } from "../data/business";

// Fixed circular brand unit: the original Rö mark stays still inside an
// animated external text ring (the only part that moves).
export default function BrandMark({ id = "ring", className = "", light = false }) {
  const pathId = `ro-${id}-path`;
  return (
    <Link to="/" className={`ro-brand ${light ? "ro-brand--light" : ""} ${className}`} aria-label="RollOver home">
      <svg className="ro-brand__ring" viewBox="0 0 210 210" aria-hidden="true">
        <defs>
          <path id={pathId} d="M105,105m-84,0a84,84 0 1,1 168,0a84,84 0 1,1 -168,0" />
        </defs>
        <text>
          <textPath href={`#${pathId}`} textLength="527">
            {business.ringText}
          </textPath>
        </text>
      </svg>
      <img src={mark} alt="" width="108" height="108" className="ro-brand__mark" />
    </Link>
  );
}
